import { render, staticRenderFns } from "./ResearchCenter.vue?vue&type=template&id=f1c1e196&scoped=true&"
import script from "./ResearchCenter.vue?vue&type=script&lang=js&"
export * from "./ResearchCenter.vue?vue&type=script&lang=js&"
import style0 from "./ResearchCenter.vue?vue&type=style&index=0&id=f1c1e196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c1e196",
  null
  
)

export default component.exports